export default "__VITE_ASSET__Bx6vPoa4__"